// biome-ignore-all lint/correctness/useExhaustiveDependencies: intentional
import { type DependencyList, useCallback, useMemo, useRef } from 'react';

import { isEqual } from 'lodash-es';

function useDeepCompareMemoize(dependencies: DependencyList) {
  const dependenciesRef = useRef<DependencyList>(dependencies);
  const signalRef = useRef<boolean>(true);

  if (!isEqual(dependencies, dependenciesRef.current)) {
    dependenciesRef.current = dependencies;
    signalRef.current = !signalRef.current;
  }

  return useMemo(() => dependenciesRef.current, [signalRef.current]);
}

export function useDeepCompareMemo<T>(
  factory: () => T,
  dependencies: DependencyList,
) {
  return useMemo(factory, useDeepCompareMemoize(dependencies));
}

// biome-ignore lint/complexity/noBannedTypes: That's how react defines it
export function useDeepCompareCallback<T extends Function>(
  callback: T,
  dependencies: DependencyList,
) {
  return useCallback(callback, useDeepCompareMemoize(dependencies));
}
